module.exports = __webpack_public_path__ + "img/logoMobile.4e928b97.svg";